export enum RateType {
  DISCOUNT = 0,
  BILL_RATE = 1,
}

export enum RateEntity {
  PROJECT = 0,
  PROJECT_PERSON = 1,
}

export interface RateInterval {
  sort_key: string;
  entity_id: string;
  entity: RateEntity;
  project_id: string;
  start_date: Date;
  end_date: Date | null;
  type: RateType;
  /* Is used as a number in the backend, but treated by the frontend like a string for editing purposes */
  amount: string;
  // Rewrite-history override (see docs/features/rewrite-history-override.md).
  // Stamped on the row by the override modal; consumed by the backend gate
  // and stripped before persist. Cleared when the row round-trips.
  override_rewrite_history?: boolean;
  override_reason?: string;
}

export const RateEntityNames: { [key in RateEntity]: string } = {
  [RateEntity.PROJECT]: 'Project',
  [RateEntity.PROJECT_PERSON]: 'Person',
};

/*
 * The userfriendly names of \ref RateType
 */
export const RateTypeNames: { [key in RateType]: string } = {
  [RateType.DISCOUNT]: 'Discount',
  [RateType.BILL_RATE]: 'Bill Rate',
};

export enum DiscountType {
  PERCENTAGE = 0,
  CURRENCY = 1,
}

/*
 * The userfriendly names of \ref DiscountType
 */
export const DiscountTypeNames: { [key in DiscountType]: string } = {
  [DiscountType.PERCENTAGE]: 'Percentage (%)',
  [DiscountType.CURRENCY]: '',
};

export interface Discount extends RateInterval {
  discount_type: DiscountType;
  description: string;
}

export enum BillRateType {
  MONTHLY = 0,
  DAILY = 1,
  MILESTONE = 2,
}

/*
 * The userfriendly names of \ref BillRateType
 */
export const BillRateTypeNames: { [key in BillRateType]: string } = {
  [BillRateType.MONTHLY]: 'Monthly',
  [BillRateType.DAILY]: 'Daily',
  [BillRateType.MILESTONE]: 'Milestone',
};

export interface BillRate extends RateInterval {
  name: string;
  br_type: BillRateType;
}

export interface PurchaseOrderNumber {
  id: string;
  start_date: Date;
  end_date: Date | null;
  number: string;
  vat: boolean;
  // Rewrite-history override (see docs/features/rewrite-history-override.md).
  override_rewrite_history?: boolean;
  override_reason?: string;
}

// Rewrite-history override fields. Used on form payloads (BillRate,
// Discount, ProjectExpense, Project) to bypass the backend rewrite_history
// gate via the audit-logged override flow.
export interface RewriteHistoryOverride {
  override_rewrite_history?: boolean;
  override_reason?: string;
}
